import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Typography, Breadcrumbs, Link as MuiLink, List, ListItem, ListItemText, Paper, Box, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { roadmaps, topics as topicCatalog } from './data';
import './learn.css';

const MotionListItem = motion(ListItem);

const RoadmapPage = () => {
  const { roadmapId } = useParams();
  const roadmap = useMemo(() => roadmaps.find(r => r.id === roadmapId), [roadmapId]);

  if (!roadmap) {
    return (
      <Container maxWidth="md" sx={{ mt: 6 }}>
        <Typography variant="h5">Roadmap not found.</Typography>
        <Button component={Link} to="/learn" sx={{ mt: 2 }} variant="contained">Back to Learn</Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" className="roadmap-container">
      <Box sx={{ mt: 3, mb: 1 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <MuiLink component={Link} underline="hover" color="inherit" to="/learn">
            Learn
          </MuiLink>
          <Typography color="text.primary">{roadmap.title}</Typography>
        </Breadcrumbs>
      </Box>

      <Paper elevation={2} className="roadmap-hero" sx={{ backgroundImage: `url(${roadmap.image})` }}>
        <Box className="roadmap-hero-overlay">
          <Typography variant="h3" component="h1">{roadmap.title}</Typography>
          <Typography variant="subtitle1">{roadmap.description}</Typography>
          {roadmap.topics?.length > 0 && (
            <Button
              component={Link}
              to={`/learn/${roadmap.id}/${roadmap.topics[0]}`}
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
            >
              Start Learning
            </Button>
          )}
        </Box>
      </Paper>

      <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>Topics in this roadmap</Typography>
      <List>
        {roadmap.topics.map((tid, idx) => {
          const t = topicCatalog[tid];
          if (!t) return null;
          return (
            <MotionListItem
              key={tid}
              divider
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.05 }}
              secondaryAction={
                <Button component={Link} to={`/learn/${roadmap.id}/${tid}`} variant="outlined" size="small">Open</Button>
              }
            >
              <ListItemText
                primary={`${idx + 1}. ${t.title}`}
                secondary={t.summary}
              />
            </MotionListItem>
          );
        })}
      </List>
    </Container>
  );
};

export default RoadmapPage;
